<template>
   <div>
    <!-- Footer -->
        <footer class="page-footer font-small blue">
          <!-- <Sponsorsliding/> -->
         
        <!-- Copyright -->
        <div class="footer-copyright text-center py-3">©{{ new Date().getFullYear() }}
             Hampshire Puja and Cultural Association
        </div>
        <!-- Copyright -->
        
        </footer>
        <!-- Footer --> 

   </div>
</template>

<script>

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Sponsorsliding from '@/components/sections/Sponsorsliding'

  export default {
    name: 'Footernav',
    components: {
      Sponsorsliding,
      
    },
    data () {
      return {
        msg: 'Footernav'
    }
  }
}

</script>

<style> 
</style>


// WEBPACK FOOTER //
// src/components/sections/Footernav.vue